export default {
  data () {
    return {
      language: null
    };
  },
  computed: {
    languages () {
      return this.$_CONFIG ? this.$_CONFIG.languages : null;
    }
  },
  mounted () {
    this.language = this.$i18n.locale;
    this.$eventBus.$on(
      'native-messageFromControl',
      this.onMessageFromControlInLanguage
    );
    this.$eventBus.$on('i18n_locale_modified', this.onI18nLocaleModified);
  },
  beforeDestroy () {
    this.$eventBus.$off(
      'native-messageFromControl',
      this.onMessageFromControlInLanguage
    );
    this.$eventBus.$off('i18n_locale_modified', this.onI18nLocaleModified);
  },
  methods: {
    languageChange () {
      this.$eventBus.$emit('change-language', this.language);
    },
    onI18nLocaleModified () {
      this.language = this.$i18n.locale;
    },
    onMessageFromControlInLanguage ({ message }) {
      try {
        if (message.scope === 'language') {
          if (
            message.type === 'task' && Object.prototype.hasOwnProperty.call(this, message.data.task)
          ) {
            if (Object.prototype.hasOwnProperty.call(message.data, 'param')) {
              this[message.data.task](message.data.param);
            } else {
              this[message.data.task]();
            }
          } else if (
            message.type === 'input' &&
            Object.prototype.hasOwnProperty.call(this, message.data.field)
          ) {
            this[message.data.field] = message.data.value;
          }
        }
      } catch (err) {}
    }
  }
};
